export default ({ request }) => ({
 masterGreyFabricListApi(data = {}) {
    return request({
      url: '/digitalCenter/masterGreyFabric/list',
      method: 'post',
      data,
    })
  },
  masterGreyFabricDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/masterGreyFabric/detail',
      method: 'post',
      data,
    })
  },
  masterGreyFabricSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/masterGreyFabric/save',
      method: 'post',
      data,
    })
  },
  masterGreyFabricDelApi(data = {}) {
    return request({
      url: '/digitalCenter/masterGreyFabric/del',
      method: 'post',
      data,
    })
  },
  masterGreyFabricImageListApi(data = {}) {
    return request({
      url: '/digitalCenter/masterGreyFabricImage/list',
      method: 'post',
      data,
    })
  },
  masterGreyFabricImageUploadApi(data = {}) {
    return request({
      url: '/digitalCenter/masterGreyFabricImage/upload',
      method: 'post',
      data,
    })
  },
  masterGreyFabricImageSetDefaultApi(data = {}) {
    return request({
      url: '/digitalCenter/masterGreyFabricImage/setDefault',
      method: 'post',
      data,
    })
  },
  masterGreyFabricImageDelApi(data = {}) {
    return request({
      url: '/digitalCenter/masterGreyFabricImage/del',
      method: 'post',
      data,
    })
  },
})
